import { Button, Stack, Typography } from '@mui/material'

import { Maybe, PaymentDetailFragment } from '@/clients/utoniq-core/schema'
import { StorageImage, useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { generateCreditCardLogoPath } from '@/core/creditCard'

type PaymentMethodCellProps = {
  paymentSource: Maybe<PaymentDetailFragment>
}

export const PaymentMethodCell: Cell<PaymentMethodCellProps> = ({
  paymentSource,
}) => {
  const { t } = useTranslation('personalInfoSettings')
  const { routerPages } = useRouter()

  return (
    <CellFrame sx={{ py: 6 }}>
      <Stack
        pb={4}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="subtitle1" color="text.secondary">
          {t('paymentMethod', '支払い方法')}
        </Typography>
        {paymentSource && (
          <Button
            variant="outlined"
            size="small"
            href={routerPages.PaymentDetail}
            sx={{ color: 'primary.main', borderColor: 'primary.main' }}
          >
            {t('change', '変更する')}
          </Button>
        )}
      </Stack>
      {paymentSource ? (
        <Stack
          direction="row"
          sx={{ py: 6, px: 5 }}
          spacing={5}
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <StorageImage
            width={40}
            height={32}
            src={generateCreditCardLogoPath(paymentSource.brand)}
            target="common"
          />
          <Stack flex={1} spacing={1}>
            <Typography variant="h6">
              {`**** **** **** ${paymentSource.last4}`}
            </Typography>
            <Typography variant="caption">{paymentSource.name}</Typography>
            <Typography variant="caption">
              {t('dateOfExpiry')}:{' '}
              {`${paymentSource?.expMonth}/${paymentSource?.expYear}`}
            </Typography>
          </Stack>
        </Stack>
      ) : (
        <>
          <Typography variant="body1" color="text.secondary">
            {t('emptyPaymentMethodMessage', '支払い方法の登録はありません')}
          </Typography>
        </>
      )}
    </CellFrame>
  )
}
